import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/Users/sudhanshu/c/s/web/components/common/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazySection"] */ "/Users/sudhanshu/c/s/web/components/common/lazy-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyOverlay"] */ "/Users/sudhanshu/c/s/web/components/common/property-overlay/property-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectConfigurations"] */ "/Users/sudhanshu/c/s/web/components/configuration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomerCareWidget"] */ "/Users/sudhanshu/c/s/web/components/customer-care-widget/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/Users/sudhanshu/c/s/web/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/Users/sudhanshu/c/s/web/components/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbySUPsClient"] */ "/Users/sudhanshu/c/s/web/components/nearby-sups/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyNearbyPlacesMap"] */ "/Users/sudhanshu/c/s/web/components/project-or-sup/lazy-nearby-places-map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbySupsSkeleton"] */ "/Users/sudhanshu/c/s/web/components/projects/skeletons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromotionalCardsSection"] */ "/Users/sudhanshu/c/s/web/components/promotional-cards/hooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sudhanshu/c/s/web/components/replace-url.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SEOContentSetter"] */ "/Users/sudhanshu/c/s/web/components/seo-content-setter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdditionalFeatures"] */ "/Users/sudhanshu/c/s/web/components/sup/additional-features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbsWrapper"] */ "/Users/sudhanshu/c/s/web/components/sup/breadcrumbs-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SUPErrorFallback"] */ "/Users/sudhanshu/c/s/web/components/sup/error-fallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryLarge"] */ "/Users/sudhanshu/c/s/web/components/sup/gallery/large.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GallerySmall"] */ "/Users/sudhanshu/c/s/web/components/sup/gallery/small.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AmenitiesSection"] */ "/Users/sudhanshu/c/s/web/components/sup/sections/amenities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OverviewSection"] */ "/Users/sudhanshu/c/s/web/components/sup/sections/overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectDetails"] */ "/Users/sudhanshu/c/s/web/components/sup/sections/project-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyDetails"] */ "/Users/sudhanshu/c/s/web/components/sup/seller-unit/property-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SEOContentForProjectOrSup"] */ "/Users/sudhanshu/c/s/web/components/sup/seo/content-project-sup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubUnitsSection"] */ "/Users/sudhanshu/c/s/web/components/sup/subunits-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SUPTitle"] */ "/Users/sudhanshu/c/s/web/components/sup/title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnitPageTracking"] */ "/Users/sudhanshu/c/s/web/components/sup/unit-page-tracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnitNotFound"] */ "/Users/sudhanshu/c/s/web/components/units/unit-not-found.tsx");
;
import(/* webpackMode: "eager" */ "/Users/sudhanshu/c/s/web/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/sudhanshu/c/s/web/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["sortMediaList"] */ "/Users/sudhanshu/c/s/web/utils/sup/sort-media-list.ts");
